<template>
	<div class="investors-form">
		<div class="investors-form__offer">
			<div class="investors-form__offer-title">
				<h1 class="investors-form__offer-title--text">Investidores da Oferta</h1>
			</div>
			<div
				class="investors-form__offer-form"
				v-for="(investor, index) in offerInvestors"
				:key="index"
			>
				<div class="investors-form__direction">
					<div class="investors-form__direction-margins investors-form__direction-margins--variant">
						<MultiselectGroup
							:isWeb="isWeb"
							:label="'Investidor:'"
							:type="`investor_${index + 1}`"
							:options="investorOptions"
							:placeholder="'Nome do Investidor'"
							:alert="false"
							:multiple="false"
							:ref="`investor_${index + 1}`"
							@changeMultiselectInput="changeInvestorInput"
						/>
					</div>
					<div class="investors-form__direction-margins investors-form__direction-margins--variant">
						<InputGroup
							:title="'Valor Investido'"
							:customClass="'full'"
							:id="`invested_${index + 1}`"
							:ref="`invested_${index + 1}`"
							:placeholder="'Inserir valor investido'"
							:isMoney="true"
							@input="changeInvestedInput($event, index + 1)"
						/>
					</div>
				</div>
				<div class="investors-form__offer-form--delete" @click="removeInvestor(investor)">
					<span>Excluir Investidor</span>
				</div>
			</div>
			<span
				class="investors-form__offer-title--icon investors-form__offer-title--subText"
				@click="addNewInvestor()"
			>
				Incluir Investidor <PlusIconVariant />
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import InputGroup from '@/components/modules/Offer/OfferDetail/InputGroup/InputGroup.vue';
import MultiselectGroup from '@/components/modules/Offer/OfferDetail/MultiselectGroup/MultiselectGroup.vue';
import PlusIconVariant from '@/components/shared/Icons/PlusIconVariant.vue';
import ArrowIcon from '@/components/shared/Icons/ArrowIcon.vue';

export default {
	name: 'OfferInvestorsForm',
	components: {
		InputGroup,
		MultiselectGroup,
		PlusIconVariant,
		ArrowIcon,
	},
	props: {
		isWeb: {
			required: true,
		},
		isEditing: {
			required: true,
		},
	},
	data: () => ({
		offer: {
			offerInvestors: [
				{
					id: null,
					invested: null,
					createdAt: null,
					deletedAt: null,
					investor: {
						cnpj: null,
						createdAt: null,
						deletedAt: null,
						fantasy_name: null,
						hasNDA: null,
						id: null,
						name: null,
					},
					index: 1,
				},
			],
		},
	}),
	methods: {
		addNewInvestor() {
			this.offer.offerInvestors.push({
				id: null,
				invested: 0.0,
				createdAt: null,
				deletedAt: null,
				investor: {
					cnpj: null,
					createdAt: null,
					deletedAt: null,
					fantasy_name: null,
					hasNDA: null,
					id: null,
					name: null,
				},
				index: this.offer.offerInvestors.length + 1,
			});
		},
		removeInvestor(param) {
			//param.index é o index da LISTA e não do objeto investor
			this.offer.offerInvestors.splice(param.index - 1, 1);

			this.offer.offerInvestors.forEach((investor, index) => {
				investor.index = index + 1;

				this.$refs[`investor_${index + 1}`][0].setValue(investor.investor);
				this.$refs[`invested_${index + 1}`][0].setMoneyValue(investor.invested);
			});
		},
		changeInvestorInput(param) {
			const typeIndex = param.type.split('_')[1];
			this.offer.offerInvestors[typeIndex - 1].investor = param.value;
		},
		changeInvestedInput(param, index) {
			if (param > 0) {
				this.offer.offerInvestors[index - 1].invested = param;
			}
		},
		loadOfferDetails(selectedOffer) {
			this.offer.offerInvestors = selectedOffer.offerInvestors.map((investor, index) => {
				const updatedInvestor = { ...investor, index: index + 1 };

				this.updateRefsWithInvestorValues(updatedInvestor, index);

				return updatedInvestor;
			});
		},
		updateRefsWithInvestorValues(investor, index) {
			setTimeout(() => {
				this.$refs[`investor_${index + 1}`][0].setValue(investor.investor);
				this.$refs[`invested_${index + 1}`][0].setMoneyValue(investor.invested);
			}, 500);
		},
		getInvestedValue() {
			for (const [i, investors] of this.offer.offerInvestors.entries()) {
				investors.invested = this.$refs[`invested_${i + 1}`][0].getMoneyValue();
			}
		},
		getOfferInvestorsData() {
			this.getInvestedValue();
			return this.offer;
		},
	},
	computed: {
		...mapGetters('investor', ['investorList']),
		investorOptions() {
			return this.investorList.length ? this.investorList : [];
		},
		offerInvestors() {
			return this.offer.offerInvestors.length ? this.offer.offerInvestors : [];
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferInvestorsForm.scss';
</style>
